import React, { useEffect, useState } from 'react';
import Address from './SubTab/Address'
import Accordion from 'react-bootstrap/Accordion';
import Select from 'react-select';
import AddShipment from './AddEdit/AddShipment';
import EditShipment from './AddEdit/EditShipment';

const ShipmentTab = () => {
    const quoteOptions = [
        { value: 1, label: "Quotation 1" },
        { value: 2, label: "Quotation 2" },
        { value: 3, label: "Quotation 3" },
        { value: 4, label: "Quotation 4" },
        { value: 5, label: "Quotation 5" },
    ]
    const customHouseOptions = [
        { value: 1, label: "CH 1" },
        { value: 2, label: "CH 2" },
        { value: 3, label: "CH 3" },
        { value: 4, label: "CH 4" },
        { value: 5, label: "CH 5" },
    ]

    const [showAdd, setShowAdd] = useState(false);
    const handleCloseAdd = () => setShowAdd(false);
    const handleShowAdd = () => setShowAdd(true);

    const [showEdit, setShowEdit] = useState(false);
    const handleCloseEdit = () => setShowEdit(false);
    const handleShowEdit = () => setShowEdit(true);

    return (
        <>
            <div className="row border-bottom-2 pb-3">
            <div className="col-md-12">
                <div className="card px-3 py-2">
                    <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-1">
                        <div className="d-flex align-items-center flex-wrap row-gap-2">
                            
                        </div>
                        <div className="d-flex align-items-center flex-wrap row-gap-2">
                            <a className="btn btn-light me-2">Clear</a>
                            <div className="btn btn-primary cursor-pointer me-2" onClick={handleShowAdd}>
                                <i className="ti ti-square-rounded-plus me-2" />
                                Add Shipment
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="table-responsive">
                        <table className="table table-striped table-sm">
                            <thead>
                                <tr>
                                    <th scope="col">S. No.</th>
                                    <th scope="col">Airline</th>
                                    <th scope="col">Flight No</th>
                                    <th scope="col">Flight / Inward Date</th>
                                    <th scope="col">IGM No</th>
                                    <th scope="col">IGM Date</th>
                                    <th scope="col">MAWB No</th>
                                    <th scope="col">MAWB Date	</th>
                                    <th scope="col">HAWB No</th>
                                    <th scope="col">HAWB Date</th>
                                    <th scope="col">Line No.</th>
                                    <th scope="col">Packages</th>
                                    <th scope="col">Gross Wt</th>
                                    <th scope="col">Net Wt</th>
                                    <th scope="col">Volume</th>
                                    <th scope="col">Chargeable Wt</th>
                                    <th scope="col">Marks & Nos</th>
                                    <th scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th scope="col">1</th>
                                    <th scope="col">-</th>
                                    <th scope="col">-</th>
                                    <th scope="col">-</th>
                                    <th scope="col">-</th>
                                    <th scope="col">-</th>
                                    <th scope="col">-</th>
                                    <th scope="col">-</th>
                                    <th scope="col">-</th>
                                    <th scope="col">-</th>
                                    <th scope="col">-</th>
                                    <th scope="col">-</th>
                                    <th scope="col">-</th>
                                    <th scope="col">-</th>
                                    <th scope="col">-</th>
                                    <th scope="col">-</th>
                                    <th scope="col">-</th>
                                    <th scope="col">
                                        <div className="dropdown table-action">
                                            <a
                                                className="action-icon"
                                                data-bs-toggle="dropdown"
                                                href="/flexichain/airline"
                                            >
                                                <i className="fa fa-ellipsis-v" />
                                            </a>
                                            <div className="dropdown-menu dropdown-menu-right">
                                                <div className="dropdown-item cursor-pointer" onClick={handleShowEdit}>
                                                    <i className="ti ti-edit text-blue me-2" /> Edit
                                                </div>
                                            </div>
                                        </div>
                                    </th>
                                </tr>
                            </tbody>
                        </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <AddShipment showAdd={showAdd} handleCloseAdd={handleCloseAdd} />
        <EditShipment showAdd={showEdit} handleCloseAdd={handleCloseEdit} />

        </>
    )
}

export default ShipmentTab